import './app/globals.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'
import { fetchEntityInfo, getBaseUrl } from './shared/config'

// Dynamic favicon from entity logo
fetchEntityInfo().then((entity) => {
  const url = entity?.logo
    ? `https://${getBaseUrl()}/v1/cdn/public/${entity.logo}`
    : null
  if (!url) return
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    || Object.assign(document.createElement('link'), { rel: 'icon' })
  link.href = url
  document.head.appendChild(link)
})

// Global error handlers — prevent unhandled errors from crashing the page
window.addEventListener('error', (event) => {
  console.error('[GlobalError]', event.error?.message || event.message, event.error?.stack)
  // Prevent page crash for non-critical errors (WebRTC, network, etc.)
  if (event.error?.message?.includes('RTCPeerConnection') ||
      event.error?.message?.includes('addTrack') ||
      event.error?.message?.includes('setRemoteDescription')) {
    event.preventDefault()
  }
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('[UnhandledPromise]', event.reason?.message || event.reason, event.reason?.stack)
  // Prevent crash for network/WebRTC promise rejections
  const msg = String(event.reason?.message || event.reason || '')
  if (msg.includes('RTCPeerConnection') || msg.includes('ICE') || msg.includes('FileService') || msg.includes('network')) {
    event.preventDefault()
  }
})

// Register service worker only in production — in dev, the SW's
// cache-first rule for /app/assets/ collides with Vite's freshly-
// generated dev assets and ships stale CSS/JS to the page on reload
// (manifests as broken layouts / wrong widths). Active dev sessions
// that already registered the SW get cleaned up below.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {})
  } else {
    void navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((r) => r.unregister())))
      .then(() => caches.keys().then((keys) => Promise.all(keys.filter((k) => k.startsWith('nexus-')).map((k) => caches.delete(k)))))
      .catch(() => {})
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
